import { Put, Post, Delete } from "./common";

export default class AdService {
  static search = async (data: any) =>
    await Post({ path: "ads/search", body: data });

  static getSimilarAds = async (data: any) =>
    await Post({ path: "ads/similar", body: data });

  static getMine = async (token: string, data: any) =>
    await Post({ path: "ads/mine", token, body: data });

  static getMineOpen = async (token: string, data: any) =>
    await Post({ path: "ads/mine-open", token, body: data });

  static getMineOne = async (token: string, data: any) =>
    await Post({ path: "ads/mine-one", token, body: data });

  static getDetailsById = async (adId: string, data: any, token = "") =>
    await Post({ path: `ads/details/${adId}`, token, body: data });

  static create = async (token: string, data: any) =>
    await Post({ path: "ads/", token, body: data });

  static update = async (token: string, id: string, data: any) =>
    await Put({ path: `ads/update/${id}`, token, body: data });

  static updateAdType = async (token: string, id: string, data: any) =>
    await Put({ path: `ads/${id}`, token, body: data });

  static updateAdStatus = async (token: string, data: any) =>
    await Post({ path: "ads/update-status", token, body: data });

  static deleteById = async (token: string, adId: string) =>
    await Delete({ path: `ads/${adId}`, token });

  static deleteAdImage = async (token: string, data: any) =>
    await Post({ path: "ads/remove-image", token, body: data });

  static getPublicAdsByUserIdAndType = async (data: any) =>
    await Post({ path: `ads/public-by-user`, body: data });

  static getTopAdsByType = async (data: any) =>
    await Post({ path: `ads/top`, body: data });
}
